import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.result');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-kiosk-result',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.result/view.scss */
/* src/app/portal.kiosk.result/view.scss: no such file or directory */`],
})
export class PortalKioskResultComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PortalKioskResultComponent;